<div class="telegram-container">
  <div class="header">
    <button class="back-button" (click)="back()">
      <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
    </button>
    <h2>{{ 'telegram.title' | translate }}</h2>
  </div>

  <div *ngIf="chatId !== null" class="telegram-connected">
    <p>{{ 'telegram.already_connected' | translate }}</p>
  </div>
  <!-- check if alreay have chatid -->

  <div class="actions">
    <button class="join-button" (click)="joinTelegram()">{{ 'telegram.join' | translate }}</button>
  </div>

  <div *ngIf="telegramLink !== ''" class="telegram-qr-code">
    <p>{{ 'telegram.scan_qr' | translate }}</p>

    <qrcode
      [qrdata]="telegramLink"
      [width]="256"
      [errorCorrectionLevel]="'M'">
    </qrcode>

  </div>

  <!-- also show link for mobile -->
  <div *ngIf="telegramLink !== ''" class="telegram-link">
    <p>{{ 'telegram.or_click_link' | translate }}</p>
    <a [href]="telegramLink">{{ 'telegram.join' | translate }}</a>
  </div>

</div>
